import React from "react";
import { Select, MenuItem, FormControl, Box, SelectChangeEvent } from "@mui/material";
import { dropdownStyle, selectStyle, selectItemStyle, dropdownItemStyle } from "./styles";

export interface DropdownOption {
  value: string;
  label: string;
  icon: React.ReactNode;
}

export interface DropdownProps {
  value: string;
  options: DropdownOption[];
  onChange: (event: SelectChangeEvent<string>, value: string) => void;
  placeholder?: DropdownOption;
  disabled?: boolean;
}

export const Dropdown: React.FC<DropdownProps> = ({ value, options, onChange, placeholder, disabled = false }) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    onChange(event, event.target.value);
  };

  return (
    <FormControl sx={dropdownStyle}>
      <Select
        value={value || ""}
        onChange={handleChange}
        displayEmpty
        disabled={disabled}
        size={"medium"}
        renderValue={selected => {
          const option = options.find(opt => opt.value === selected) ?? placeholder;
          return <Box sx={selectItemStyle}>{option?.icon}</Box>;
        }}
        sx={selectStyle}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            <Box sx={dropdownItemStyle}>
              {option.icon}
              <span>{option.label}</span>
            </Box>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
